/** Query param para deep link / compartilhamento de NSMP na tela NSIR V2. */
export const NSMP_ID_QUERY_PARAM = 'nsmpId';

/** Índice fixo da aba Serviços no detalhe NSIR (após Informação Básica). */
export const NSIR_SERVICOS_TAB_INDEX = 1;

export const getNsmpIdFromSearch = (search = '') => {
  if (!search) return null;
  return new URLSearchParams(search).get(NSMP_ID_QUERY_PARAM);
};

export const buildPathWithNsmpId = (pathname, search = '', nsmpId) => {
  const params = new URLSearchParams(search);
  if (nsmpId) {
    params.set(NSMP_ID_QUERY_PARAM, nsmpId);
  } else {
    params.delete(NSMP_ID_QUERY_PARAM);
  }
  const qs = params.toString();
  return qs ? `${pathname}?${qs}` : pathname;
};

export const syncNsmpIdInUrl = (history, location, nsmpId, { replace = true } = {}) => {
  if (!history || !location) return false;

  const nextUrl = buildPathWithNsmpId(location.pathname, location.search, nsmpId);
  const currentUrl = location.search
    ? `${location.pathname}${location.search}`
    : location.pathname;

  if (nextUrl === currentUrl) return false;

  if (replace) {
    history.replace(nextUrl);
  } else {
    history.push(nextUrl);
  }
  return true;
};
